// Extra-hours pricing shared by reports and billing pages.
// Match the original Type, not aliases used by the existing base-price formulas.
const HIGHLIGHTED_EXTRA_HOURS_TYPES = new Set([
  "coaxasbuilt", "coaxasbrevertsplit", "coaxasbrevertn+0", "coaxdesign",
  "coaxbentley", "coaxbentleyasb", "coaxbentleydes", "route", "routefttp",
  "irissplitcoaxasbuilt",
]);
const normalizeExtraHoursType = value => String(value ?? "").toLowerCase().replace(/[\s_-]+/g, "");

export function getExtraHours(row) {
  const raw = String(row?.jbhrex ?? "").trim().replace(",", ".");
  if (!/^(?:[0-9]+(?:\.[0-9]+)?|\.[0-9]+)$/.test(raw)) return 0;
  const hours = Number(raw);
  return Number.isFinite(hours) && hours > 0 ? hours : 0;
}
export function extraHoursRate(row, mode = "CLIENT") {
  const highlighted = HIGHLIGHTED_EXTRA_HOURS_TYPES.has(normalizeExtraHoursType(row?.jobti));
  return mode === "SFD" ? (highlighted ? 0 : 8.5) : (highlighted ? 20 : 17.5);
}
export function calcExtraHoursTotal(row, mode = "CLIENT") {
  // jbhrex is DECIMAL(...,2): calculate in hundredths to keep half-cent
  // rounding stable for fractional hours (e.g. 1.25 * 17.50 = 21.88).
  const hundredthsOfHour = Math.round(getExtraHours(row) * 100);
  const rateInCents = Math.round(extraHoursRate(row, mode) * 100);
  return Math.round(hundredthsOfHour * rateInCents / 100) / 100;
}
